module.exports = __webpack_public_path__ + "static/media/fast.da4bf9b0.png";